export enum ESocketEvent {
  connect = 'connect',
  updateScene = 'update:scene',
  refreshOverlay = 'update:refresh',
  updateTransition = 'update:transition',
  updateGameCapture = 'update:game-capture',
  updateSLWidgetToken = 'update:sl-widget-token',
  updateStreamStatus = 'update:stream-status',
  webcamBroadcaster = 'webcam:broadcaster',
  webcamBroadcasterDisconnect = 'webcam:broadcaster-disconnect',
  webcamPeerDisconnect = 'webcam:peer-disconnect',
  peerConnectionRequest = 'peer-connection:request',
  peerConnectionAccepted = 'peer-connection:accepted',
  peerConnectionSignal = 'peer-connection:signal',
  streamHealthStatus = 'stream:health-status',
  userStreamAttempt = 'user:stream-attempt',
  platformStreamError = 'platform:stream-error',
}

export default class SocketHelper {
  static get socketOptions() {
    return {
      forceNew: true,
      secure: true,
      reconnection: true,
      reconnectionDelay: 1000,
      timeout: 15000,
      pingTimeout: 15000,
      pingInterval: 45000,
      autoConnect: false,
      transports: ['polling'],
    };
  }
}